import React from 'react';
import { SettingsPanel as SettingsPanelComponent } from '../../../Data/partials';

export default function SettingsPanel() {
	return <SettingsPanelComponent isEmbed={true} />;
}
